export const convertDateToStr = _date => {
	return String(_date).replace(/\s/, 'T');
};
